// import { NgModule } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// import { IonicModule } from '@ionic/angular';
// import { Reserv3Component } from './reserv3.component';
// import { TranslateModule } from '@ngx-translate/core';
// import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
// import { DropdownModule } from 'src/app/components/dropdown/dropdown.component.module';
// import { MatSelectModule } from '@angular/material/select';
// import { SafeHtmlsModule } from 'src/app/angular-wallet-base/pipes/safe-htmls/safe-htmls.module';


// @NgModule({
//   imports: [
//     CommonModule,
//     FormsModule,
//     IonicModule,
//     TranslateModule,
//     ReactiveFormsModule,
//     NgxIntlTelInputModule,
//     DropdownModule,
//     MatSelectModule,
//     SafeHtmlsModule
//   ],
//   declarations: [Reserv3Component]
// })
// export class Reserv3PageModule { }
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { Reserv3Component } from './reserv3.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


const routes: Routes = [
  {
    path: '',
    component: Reserv3Component,
  },
];

@NgModule({
  declarations: [
    Reserv3Component
  ],
  imports: [
    RouterModule.forChild(routes),
    IonicModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ]
})
export class Reserv3PageModule { }
